// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__floP9","label":"style_label__5k2D6"};